<template>
  <div class="social-icons">
    <p class="social-icons__title">
      <slot name="title" />
    </p>
    <div
      class="social-icons__container"
      @click="pushGTM"
    >
      <slot name="icons" />
    </div>
  </div>
</template>

<script>
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'social-icons',
  methods: {
    pushGTM(event) {
      const target = event.target.closest('a')

      if (target) {
        window.dataLayer.push({
          event: 'click',
          section: 'redes-sociais',
          label: target.innerText || target.getAttribute('aria-label') || '',
          outbound: isOutbound(target)
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.social-icons {
  display: flex;
  gap: 1rem;
  flex-direction: column;

  &__title {
    @include font-telegraf(400);
    color: $neutral-01;
    font-size: 1.25rem;
    line-height: 1.75rem;
    text-align: left;
  }

  &__container {
    display: flex;
    gap: 1rem;
  }
}
</style>
